module.exports = __webpack_public_path__ + "media/images/front/icon_plus_gr-f743218288a59bb0f735a1718d85986b.png";